/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";

import { API, graphqlOperation } from "aws-amplify";
import { getAccount } from "../../../graphql/account/account-queries";

import { isEmpty } from "lodash";

import {
  Grid,
  InputAdornment,
  TextField as MuiTextField,
  Typography,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";

import {
  ArrayField,
  ArrayInput,
  Button,
  CheckboxGroupInput,
  Create,
  Datagrid,
  FileInput,
  FormDataConsumer,
  FormTab,
  FunctionField,
  ListContextProvider,
  minValue,
  number,
  NumberField,
  NumberInput,
  RadioButtonGroupInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useList,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import {
  AddIcon,
  ArrivedAtIcon,
  AttachFileIcon,
  CreatedAtIcon,
} from "../../../components/common/iconography";
import { AddressInput } from "../../../components/common/AddressInput";
import { BackButton } from "../../../components/common/BackButton";
import { CarrierNameInput } from "../../../components/common/CarrierNameInput";
import { CopyToClipboardButton } from "../../../components/common/CopyToClipboardButton";
import {
  CustomField,
  CustomFields,
} from "../../../components/common/CustomFields";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { NotesTab } from "../../../components/common/NotesTab";
import { FileField } from "../../../components/common/FileField";
import CustomizableDatagrid from "../../../components/common/ra-customizable-datagrid";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { BetaBadge, NewBadge } from "../../../components/common/FeatureBadges";
import PhotoInput from "../../../components/common/PhotoInput";
import { SmartTipIcon } from "../../../components/common/SmartTipIcon";
import { EventsCalendar } from "../../../components/common/EventsCalendar";
import { Scheduler } from "../../../components/common/scheduler/Scheduler";

import {
  fetchSavedAddresses,
  getEffectiveSkipInvoice,
  isBrokeredAccount,
  isInternalAccount,
  resolveBillToAccount,
} from "../accounts/AccountUtils";
import {
  fetchOutboundBillingRules,
  filterApplicableManualRules,
  getManualRuleChoices,
} from "../accounts/chargeRules/ChargeRuleUtils";
import { ChargeEvent } from "../accounts/chargeRules/chargeRuleConstants";
import { logError } from "../../../utils/appUtils";
import { handleFileChange } from "../../../utils/fileUtils";
import {
  getRailEquipmentTypes,
  getTruckEquipmentTypes,
  getUnitName,
} from "../../../utils/loadTypeUtils";
import {
  resolveScheduledDateTime,
  getDateTimeFromUtc,
} from "../../../utils/dateUtils";
import { piecesRenderer } from "../../../utils/utils";
import {
  ACCEPTED_FILES,
  CarrierType,
  CarrierTypes,
  FilePaths,
  MAX_FILES,
  MAX_PHOTO_NUM_OUTBOUND,
  ResourceType,
  TrueOrFalse,
  Workflow,
} from "../../../utils/constants";

import { OutboundCreateHelp } from "./OutboundHelp";
import { InventorySearchDialog } from "./InventorySearchDialog";
import { ValidateCreateButton } from "./ValidaateCreateButton";
import {
  applyManualRuleDefaultQuantity,
  calcNetWeight,
  calcTotalQuantity,
  fetchSetupData,
  getAllInventories,
  getInfoBubble,
  getSaveAddressControl,
  getTransferOptions,
  handleContainerPickupChange,
  handleMustTarpChange,
  handlePickListWeight,
  getAutoCharges,
  getManualChargeAmount,
  InventoryItemsArrayInput,
  isInternalTransfer,
  isOutboundDuplicateReferenceField,
  resetPickList,
  setupAccountDetails,
  ShipmentItemCreateActionButtons,
  duplicateReferenceFieldHelperText,
  outboundDuplicateLabelsToFieldSources,
  validateOutboundUnicity,
  validateRefernceNumberUnicity,
} from "./OutboundUtils";
import { AddressBookSelect } from "./AddressBookSelect";

const validateRequired = required();

// A rail shipment cannot be created without the railroad's name; a truck load can,
// since the carrier is often not known until dispatch. Shared by both branches of
// the carrierName input so the rule does not depend on which one is rendered.
const validateCarrierName = (value, allValues) =>
  allValues?.carrierType === CarrierType.RAIL
    ? validateRequired(value)
    : undefined;

export const ShipmentSetupTab = ({
  account,
  setAccount,
  toAccount,
  setToAccount,
  operatingAccount,
  setOperatingAccount,
  setShipmentLineItems,
  setIsContainerPickUp,
  photos,
  setPhotos,
  ...props
}) => {
  const form = useForm();
  const notify = useNotify();
  const [loading, setLoading] = useState(true);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const CarrierTypesReversed = [].concat(CarrierTypes).reverse();
  const [railEquipmentChoices, setRailEquipmentChoices] = useState(
    getRailEquipmentTypes(),
  );
  const [truckEquipmentChoices, setTruckEquipmentChoices] = useState(
    getTruckEquipmentTypes(),
  );
  const [carrierEquipmentChoices, setCarrierEquipmentChoices] = useState([]);
  const [duplicateReferenceFields, setDuplicateReferenceFields] = useState([]);
  // The account dropdown stays selectable while its lookups run, so a second
  // pick before the first resolves leaves two handlers racing and the slower
  // one wins. Each handler records the selection it is working on here and
  // stops once a newer selection has taken over.
  const accountRequestRef = useRef(null);

  useEffect(() => {
    fetchSetupData(
      setLoading,
      setRailEquipmentChoices,
      setTruckEquipmentChoices,
      notify,
    );
  }, []);

  // Subscribe to field state updates for 3rd party inputs
  form.registerField(
    "billToAccountId",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );

  const handleAccountChange = async (value) => {
    const accountId = value?.id ?? null;
    // Claimed before the accountId check so that clearing the field also
    // invalidates whatever lookup is still in flight.
    accountRequestRef.current = accountId;
    const isCurrentSelection = () => accountRequestRef.current === accountId;
    if (accountId) {
      try {
        debugger;
        setLoading(true);
        resetPickList(form, setShipmentLineItems, notify);
        form.change("transferToAccountId", "");

        let resp = await API.graphql(
          graphqlOperation(getAccount, { id: accountId }),
        );
        if (!isCurrentSelection()) return;
        const acct = resp.data.getAccount;
        // BROKERED: shipment bills to the broker, so skipInvoice follows the
        // broker; the operating account's own flag would hide billing forever.
        // The broker fetch only needs acct, so it rides along with the
        // addresses instead of adding a third sequential round trip.
        const [addressArr, broker] = await Promise.all([
          fetchSavedAddresses(accountId, notify),
          resolveBillToAccount(acct),
        ]);
        if (!isCurrentSelection()) return;
        acct.savedAddresses = {
          items: Array.isArray(addressArr) ? addressArr : [],
        };
        form.change("skipInvoice", getEffectiveSkipInvoice(acct, broker));
        setAccount(acct);
        setToAccount(null);
        form.change("transfer", undefined);
        setupAccountDetails(acct, null, null, form, setOperatingAccount);
      } catch (err) {
        logError(
          "outboundShipment:OutboundCreate:handleAccountChange",
          err,
          // A superseded lookup still logs, but notifying would raise an error
          // about an account the user has already moved off.
          isCurrentSelection() ? notify : false,
        );
      } finally {
        // The current handler owns the spinner; a superseded one must leave it.
        if (isCurrentSelection()) setLoading(false);
      }
    }
  };

  const handleOperatingAccountChange = async (selectedAccount) => {
    // only applicable in context of internalAccount.
    try {
      if (!selectedAccount) {
        // operatingAccount = account
        setupAccountDetails(account, null, null, form, setOperatingAccount);
      } else {
        // if source accont is pass-through, fetch operatingAccount for billing and settings
        let resp = await API.graphql(
          graphqlOperation(getAccount, { id: selectedAccount.id }),
        );
        const acct = resp.data.getAccount;
        const addressArr = await fetchSavedAddresses(acct.id, notify);
        acct.savedAddresses = {
          items: Array.isArray(addressArr) ? addressArr : [],
        };
        setupAccountDetails(account, acct, null, form, setOperatingAccount);

        // must be either transferTo or billTo
        form.change("transfer", undefined);
        form.change("transferToAccountId", "");
      }
    } catch (err) {
      logError(
        "outboundShipment:OutboundCreate:handleBillToAccountChange",
        err,
        notify,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTransferChange = (value) => {
    // single-select checkbox logic
    const transfer = value.length === 2 ? [value[1]] : value;
    form.change("transfer", transfer);

    if (transfer?.length === 0) {
      // if not a transfer, then operatingAccount = fromAccount.
      setupAccountDetails(account, null, null, form, setOperatingAccount);
    } else {
      form.change("skipSignature", true);
      form.change("billToAccountId", "");
      form.change("transferToAccountId", "");
    }
  };

  const getAccountHelperText = () => {
    if (isInternalAccount(account)) return "Internal Account";
    if (isBrokeredAccount(account)) return "Brokered Account";
    return false;
  };

  const handleAccountReferenceBlur = async () => {
    const values = form.getState().values;
    const duplicateLabels = await validateOutboundUnicity(values);
    if (duplicateLabels.length > 0 && notify) {
      notify("Duplicate reference number", "warning", {
        autoHideDuration: 15000, // in milliseconds (15 seconds)
      });
    }
    setDuplicateReferenceFields(
      outboundDuplicateLabelsToFieldSources(duplicateLabels),
    );
  };

  const handleReferenceNumberBlur =
    (fieldSource, normalizedFieldSource) => async () => {
      const isDuplicate = await validateRefernceNumberUnicity(
        form.getState().values,
        normalizedFieldSource,
        notify,
      );
      setDuplicateReferenceFields((prev) => {
        const next = new Set(prev);
        if (isDuplicate) next.add(fieldSource);
        else next.delete(fieldSource);
        return [...next];
      });
    };

  const handleAddressBookEntryUpdated = (updated) => {
    const replace = (items) =>
      items?.map((a) => (a.id === updated.id ? updated : a)) ?? items;
    setAccount((prev) =>
      prev
        ? { ...prev, savedAddresses: { items: replace(prev.savedAddresses?.items) } }
        : prev,
    );
    setOperatingAccount((prev) =>
      prev
        ? { ...prev, savedAddresses: { items: replace(prev.savedAddresses?.items) } }
        : prev,
    );
  };

  const outboundCustomFields = (operatingAccount || account)
    ?.outboundCustomFields;
  const customFieldsSection =
    outboundCustomFields?.length > 0 ? (
      <CustomFields
        {...props}
        accountFields={outboundCustomFields}
        width={4}
        disabled={false}
      />
    ) : null;

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container direction="row" spacing={3}>
          <Grid item container direction="column" spacing={0} lg={8}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <AccountDropDown
                  source="accountId"
                  label="Account"
                  allowEmpty={false}
                  validate={validateRequired}
                  onAccountChange={(value) => handleAccountChange(value)}
                  loading={loading}
                  helperText={getAccountHelperText()}
                  alertOverDue={true}
                  onBlur={handleAccountReferenceBlur}
                />
              </Grid>
              {isInternalAccount(account) && isEmpty(formData.transfer) && (
                <Grid item xs={12} md={4}>
                  <AccountDropDown
                    source="billToAccountId"
                    label="Billing Account"
                    excludeAccountIds={account?.id ? [account?.id] : []}
                    validate={validateRequired}
                    allowEmpty={false}
                    onAccountChange={handleOperatingAccountChange}
                    loading={loading}
                    helperText={false}
                  />
                </Grid>
              )}
              {isBrokeredAccount(account) &&
                account.defaultBillToAccountId &&
                isEmpty(formData.transfer) && (
                  <Grid item xs={12} md={4}>
                    <AccountDropDown
                      source="billToAccountId"
                      label="Billing Account"
                      disabled={true}
                      helperText={false}
                    />
                  </Grid>
                )}
              <Grid item xs={12} sm={6} md={4}>
                <CheckboxGroupInput
                  source="transfer"
                  label="Inventory Transfer"
                  fullWidth
                  choices={getTransferOptions(account)}
                  onChange={handleTransferChange}
                  disabled={!account}
                  style={{ marginTop: 0 }}
                  helperText={false}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextInput
                  source="poNumber"
                  label="PO Number"
                  variant="outlined"
                  fullWidth
                  parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                  validate={validateRequired}
                  onBlur={handleReferenceNumberBlur(
                    "poNumber",
                    "normalizedPoNumber",
                  )}
                  error={isOutboundDuplicateReferenceField(
                    duplicateReferenceFields,
                    "poNumber",
                  )}
                  helperText={duplicateReferenceFieldHelperText(
                    duplicateReferenceFields,
                    "poNumber",
                  )}
                  FormHelperTextProps={{
                    component: "div",
                    style: isOutboundDuplicateReferenceField(
                      duplicateReferenceFields,
                      "poNumber",
                    )
                      ? { color: "#f44336" }
                      : undefined,
                  }}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CopyToClipboardButton
                          text={formData.poNumber || ""}
                          edge="end"
                          fontSize="small"
                          mb={0}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextInput
                  source="consigneePoNumber"
                  label="Consignee PO Number"
                  variant="outlined"
                  fullWidth
                  parse={(v) => v.toUpperCase()}
                  onBlur={handleReferenceNumberBlur(
                    "consigneePoNumber",
                    "normalizedConsigneePoNumber",
                  )}
                  error={isOutboundDuplicateReferenceField(
                    duplicateReferenceFields,
                    "consigneePoNumber",
                  )}
                  helperText={duplicateReferenceFieldHelperText(
                    duplicateReferenceFields,
                    "consigneePoNumber",
                  )}
                  FormHelperTextProps={{
                    component: "div",
                    style: isOutboundDuplicateReferenceField(
                      duplicateReferenceFields,
                      "consigneePoNumber",
                    )
                      ? { color: "#f44336" }
                      : undefined,
                  }}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                />
              </Grid>
            </Grid>

            {isEmpty(formData.transfer) ? (
              <OutboundForm
                formData={formData}
                account={account}
                setToAccount={setToAccount}
                operatingAccount={operatingAccount}
                setOperatingAccount={setOperatingAccount}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                CarrierTypesReversed={CarrierTypesReversed}
                railEquipmentChoices={railEquipmentChoices}
                truckEquipmentChoices={truckEquipmentChoices}
                carrierEquipmentChoices={carrierEquipmentChoices}
                setCarrierEquipmentChoices={setCarrierEquipmentChoices}
                setIsContainerPickUp={setIsContainerPickUp}
                setShipmentLineItems={setShipmentLineItems}
                duplicateReferenceFields={duplicateReferenceFields}
                handleReferenceNumberBlur={handleReferenceNumberBlur}
                form={form}
                notify={notify}
                onAddressUpdated={handleAddressBookEntryUpdated}
                customFields={customFieldsSection}
              />
            ) : (
              <>
                <TransferForm
                  formData={formData}
                  account={account}
                  setToAccount={setToAccount}
                  setOperatingAccount={setOperatingAccount}
                  form={form}
                  notify={notify}
                  loading={loading}
                />
                {customFieldsSection}
              </>
            )}
          </Grid>

          <Grid item container direction="row" spacing={0} xs={false} md={4}>
            <Grid item xs={12}>
              <FileInput
                source="attachments"
                label="ATTACHMENTS"
                variant="outlined"
                fullWidth
                placeholder={
                  <p>
                    <AttachFileIcon fontSize="large" /> <br /> Drop files to
                    upload, or click to select.
                  </p>
                }
                accept={ACCEPTED_FILES}
                multiple
                maxFiles={MAX_FILES}
                options={{ maxFiles: MAX_FILES }}
                onChange={(value) =>
                  handleFileChange("attachments", value, form, notify)
                }
              >
                <FileField source="src" title="title" target="_blank" />
              </FileInput>
            </Grid>
            <Grid item xs={12}>
              <FileInput
                source="bolFile"
                label="BOL FILE"
                variant="outlined"
                fullWidth
                placeholder={
                  <p>
                    <AttachFileIcon fontSize="large" /> <br /> Drop BOL file to
                    upload, or click to select.
                  </p>
                }
                accept={ACCEPTED_FILES}
                onChange={(value) =>
                  handleFileChange("bolFile", value, form, notify)
                }
              >
                <FileField source="src" title="title" target="_blank" />
              </FileInput>
            </Grid>
            <Grid item xs={12}>
              <PhotoInput
                source="photos.items"
                label="PHOTOS"
                disabled={!account}
                maxFiles={MAX_PHOTO_NUM_OUTBOUND}
                thumbs={3}
                parentType={ResourceType.OUTBOUND}
                storeDir={`${FilePaths.OUTBOUND}/${Date.now()}`}
                photos={photos}
                setPhotos={setPhotos}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const OutboundForm = ({
  formData,
  account,
  operatingAccount,
  selectedAddress,
  setSelectedAddress,
  CarrierTypesReversed,
  railEquipmentChoices,
  truckEquipmentChoices,
  carrierEquipmentChoices,
  setCarrierEquipmentChoices,
  setIsContainerPickUp,
  setShipmentLineItems,
  duplicateReferenceFields,
  handleReferenceNumberBlur,
  form,
  notify,
  onAddressUpdated,
  customFields,
}) => {
  const handleCarrierTypeChange = (event) => {
    const carrier = event?.target?.value;

    if (carrier === CarrierType.RAIL) {
      setCarrierEquipmentChoices(railEquipmentChoices);
    } else if (carrier === CarrierType.TRUCK) {
      setCarrierEquipmentChoices(truckEquipmentChoices);
    } else {
      setCarrierEquipmentChoices([]);
    }
    form.change("carrierEquipmentTypeId", "");

    if (carrier !== CarrierType.TRUCK) {
      // Only trucking companies are Carrier records, so a rail load has no id to
      // hold. Left behind, it would keep pointing at the trucking company while
      // the free-text field the rail branch renders renames the load out from
      // under it.
      form.change("carrierId", null);
      form.change("pickupNumber", "");
      form.change("mustTarp", false);
      form.change("containerPickup", false);
      form.change("skipSignature", true);
    }
  };

  const getPickupNumberHelperText = () => {
    const dupMsg = duplicateReferenceFieldHelperText(
      duplicateReferenceFields,
      "pickupNumber",
    );
    if (dupMsg) return dupMsg;
    if (account?.generatePickupNumber) return "Auto-generated";
    return false;
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <SelectInput
          source="carrierType"
          label="Carrier Type"
          variant="outlined"
          fullWidth
          disabled={!account}
          choices={CarrierTypesReversed}
          onChange={handleCarrierTypeChange}
          validate={validateRequired}
          helperText={false}
        />
      </Grid>

      {(railEquipmentChoices?.length > 0 ||
        truckEquipmentChoices?.length > 0) && (
        <Grid item xs={12} md={4}>
          <SelectInput
            source="carrierEquipmentTypeId"
            label="Carrier Equipment Type"
            choices={carrierEquipmentChoices}
            allowEmpty
            fullWidth
            disabled={!carrierEquipmentChoices?.length}
            variant="outlined"
            helperText={false}
          />
          <SmartTipIcon label="carrier-equipment-type" mt={-1} />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={4}>
        {/* Only trucking companies exist as Carrier records, so only a truck load
            has a list to pick from. A rail carrier name is the railroad's mark —
            free text with no record behind it — and it stays a plain field. */}
        {formData.carrierType === CarrierType.TRUCK ? (
          <CarrierNameInput
            source="carrierName"
            label="Carrier Name"
            validate={validateCarrierName}
          />
        ) : (
          <TextInput
            source="carrierName"
            label="Carrier Name"
            variant="outlined"
            fullWidth
            validate={validateCarrierName}
            isRequired={formData.carrierType === CarrierType.RAIL} // Manually trigger asterisk
            helperText={false}
          />
        )}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextInput
          source="railCarNumber"
          label={
            formData.carrierType === CarrierType.RAIL
              ? "Railcar Number"
              : "Trailer Number"
          }
          variant="outlined"
          fullWidth
          parse={(v) => v.toUpperCase()}
          validate={(value, allValues) =>
            allValues?.carrierType === CarrierType.RAIL
              ? validateRequired(value)
              : undefined
          }
          required={formData.carrierType === CarrierType.RAIL} // Manually trigger asterisk
          inputProps={{ style: { textTransform: "uppercase" } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CopyToClipboardButton
                  text={formData.railCarNumber || ""}
                  edge="end"
                  fontSize="small"
                  mb={0}
                />
              </InputAdornment>
            ),
          }}
          helperText={false}
        />
      </Grid>
      {formData.carrierType === CarrierType.TRUCK && (
        <Grid item xs={12} sm={6} md={4}>
          <TextInput
            source="pickupNumber"
            label="Pickup Number"
            variant="outlined"
            fullWidth
            parse={(v) => v.toUpperCase()}
            validate={
              account?.generatePickupNumber ? undefined : validateRequired
            }
            disabled={account?.generatePickupNumber}
            onBlur={handleReferenceNumberBlur(
              "pickupNumber",
              "normalizedPickupNumber",
            )}
            error={isOutboundDuplicateReferenceField(
              duplicateReferenceFields,
              "pickupNumber",
            )}
            helperText={getPickupNumberHelperText()}
            FormHelperTextProps={{
              component: "div",
              style: isOutboundDuplicateReferenceField(
                duplicateReferenceFields,
                "pickupNumber",
              )
                ? { color: "#f44336" }
                : undefined,
            }}
            inputProps={{ style: { textTransform: "uppercase" } }}
          />
        </Grid>
      )}

      {customFields && (
        <Grid item xs={12}>
          {customFields}
        </Grid>
      )}
      <Grid item xs={12}>
        <fieldset>
          <legend>
            <Typography variant="overline" color="textSecondary">
              Options
            </Typography>
          </legend>
          <Grid container direction="row" spacing={0}>
            <Grid item xs={6} md={3}>
              <RadioButtonGroupInput
                source="mustTarp"
                label="Must Tarp?"
                row
                choices={TrueOrFalse}
                onChange={(value) =>
                  handleMustTarpChange(
                    value,
                    form,
                    setIsContainerPickUp,
                    setShipmentLineItems,
                    notify,
                  )
                }
                defaultValue={false}
                disabled={formData?.carrierType !== CarrierType.TRUCK}
                validate={
                  formData?.carrierType === CarrierType.TRUCK
                    ? validateRequired
                    : undefined
                }
                helperText={false}
              />
            </Grid>
            <Grid item xs={6} md={3} style={{ display: "flex" }}>
              <RadioButtonGroupInput
                source="containerPickup"
                label="ISOtainer Pickup"
                row
                choices={TrueOrFalse}
                defaultValue={false}
                onChange={(value) =>
                  handleContainerPickupChange(
                    value,
                    form,
                    account,
                    setIsContainerPickUp,
                    setShipmentLineItems,
                    notify,
                  )
                }
                disabled={formData?.carrierType !== CarrierType.TRUCK}
                validate={validateRequired}
                helperText={false}
              />
              <BetaBadge />
            </Grid>
            <Grid item xs={6} md={3}>
              <RadioButtonGroupInput
                source="skipSignature"
                label="Skip e-signatures"
                row
                choices={TrueOrFalse}
                defaultValue={false}
                disabled={formData?.carrierType !== CarrierType.TRUCK}
                validate={validateRequired}
                helperText={false}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <RadioButtonGroupInput
                source="skipInvoice"
                label="Skip Billing"
                row
                choices={TrueOrFalse}
                defaultValue={false}
                validate={validateRequired}
                helperText={false}
              />
            </Grid>
          </Grid>
        </fieldset>
      </Grid>

      <Grid item xs={12}>
        <fieldset>
          <legend>
            <Typography variant="overline" color="textSecondary">
              Consignee Address
            </Typography>
          </legend>
          <AddressBookSelect
            addressBook={
              operatingAccount?.savedAddresses?.items?.length > 0
                ? operatingAccount.savedAddresses.items
                : account?.savedAddresses?.items
            }
            form={form}
            formData={formData}
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
            onAddressUpdated={onAddressUpdated}
          />
          <AddressInput
            source="shipTo"
            variant="outlined"
            fullWidth
            showBusinessName={true}
            showPhone={true}
            parse={(v) => (v !== "" ? v : undefined)}
            disabled={Boolean(selectedAddress)}
            allValues={formData}
          />
          {!selectedAddress &&
            getSaveAddressControl(
              account?.savedAddresses?.items, // from fetchSavedAddresses
              operatingAccount?.savedAddresses?.items, // from fetchSavedAddresses
              formData,
            )}
        </fieldset>
      </Grid>
      <Grid item xs={12}>
        <TextInput
          source="instructions"
          label="Special Instructions"
          variant="outlined"
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

const TransferForm = ({
  formData,
  account,
  setToAccount,
  setOperatingAccount,
  form,
  notify,
  loading,
}) => {
  const handleTransferToAccountChange = (selectedAccount) => {
    try {
      if (!selectedAccount?.id) {
        setToAccount(null);
        form.change("transferToAccountName", "");
        // operatingAccount = account
        setupAccountDetails(account, null, null, form, setOperatingAccount);
      } else {
        setupAccountDetails(
          account,
          null,
          selectedAccount,
          form,
          setOperatingAccount,
        );
        setToAccount(selectedAccount);
        form.change("transferToAccountName", selectedAccount.businessName);
      }
    } catch (err) {
      logError(
        "outboundShipment:OutboundCreate:handleTransferToAccountChange",
        err,
        notify,
      );
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography gutterBottom variant="overline" color="textSecondary">
            Destination Account
          </Typography>
          {isInternalTransfer(formData) ? (
            <Typography gutterBottom variant="body2">
              An "Internal Transfer" changes beneficial ownership of goods which
              continue to remain in Yard's custody.
            </Typography>
          ) : (
            <Typography gutterBottom variant="body2">
              An "External Transfer" removes goods from inventory and transfers
              to selected account.
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={4}>
          <AccountDropDown
            source="transferToAccountId"
            label="To Account"
            excludeAccountIds={account?.id ? [account.id] : []}
            validate={validateRequired}
            allowEmpty={false}
            disabled={!account}
            onAccountChange={handleTransferToAccountChange}
            loading={loading}
            helperText={false}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <RadioButtonGroupInput
            source="skipInvoice"
            label="Skip Billing"
            row
            choices={TrueOrFalse}
            defaultValue={false}
            validate={validateRequired}
            style={{ marginTop: "0" }}
            helperText={false}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

// #################################################################

const PickListTab = ({
  account,
  operatingAccount,
  isContainerPickUp,
  shipmentLineItems,
  setShipmentLineItems,
  allInventories,
  setAllInventories,
  isLoaded,
  setIsLoaded,
  ...props
}) => {
  const form = useForm();
  const location = useLocation(); // used to refresh allInventories
  const notify = useNotify();
  const [weightError, setWeightError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [chargeRules, setChargeRules] = useState([]);
  const [autoCharges, setAutoCharges] = useState([]);

  useEffect(() => {
    // refresh on account change and InventorySearchDialog close
    if (account?.id && !isOpen) {
      getAllInventories(
        account.id,
        isContainerPickUp,
        setAllInventories,
        setIsLoaded,
        notify,
      );
    }
  }, [location, isOpen, isContainerPickUp, account?.id]);

  useEffect(() => {
    // All outbound charge rules for this shipment; MANUAL + applicability is
    // filtered at render time. Rules come from the effective billing account
    // (form billToAccountId, falling back to the selected account) — the same
    // account invoicing resolves. NOT the operating account: for BROKERED
    // shipments that is a different customer, and a manual charge carries its
    // chargeRule straight onto the invoice, so offering another account's rules
    // here would bill the broker at rates never agreed with them.
    let currentBillingAccountId = null;
    let isMounted = true;

    const fetchOutboundChargeRules = async (billingAccountId) => {
      if (!billingAccountId) {
        if (isMounted) setChargeRules([]);
        return;
      }
      try {
        const rules = await fetchOutboundBillingRules(billingAccountId);
        // Out-of-order guard: a slow response for a previously selected billing
        // account must not overwrite the current account's rules.
        if (isMounted && billingAccountId === currentBillingAccountId) {
          setChargeRules(rules);
        }
      } catch (error) {
        logError(
          "outboundShipments:OutboundCreate:PickListTab:manualChargeRules",
          error,
          false,
        );
        if (isMounted && billingAccountId === currentBillingAccountId) {
          setChargeRules([]);
        }
      }
    };

    const getFormBillingAccountId = (values = {}) =>
      values?.billToAccountId || account?.id;

    currentBillingAccountId = getFormBillingAccountId(form.getState().values);
    fetchOutboundChargeRules(currentBillingAccountId);

    const unsubscribe = form.subscribe(
      ({ values }) => {
        const nextBillingAccountId = getFormBillingAccountId(values);
        if (nextBillingAccountId !== currentBillingAccountId) {
          currentBillingAccountId = nextBillingAccountId;
          fetchOutboundChargeRules(nextBillingAccountId);
        }
      },
      { values: true },
    );

    return () => {
      isMounted = false;
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account?.id]);

  useEffect(() => {
    // Subscribe to form changes to calculate auto charges, est. net weight and total quantity
    const unsubscribe = form.subscribe(
      ({ values }) => {
        const outbound = values;
        setAutoCharges(getAutoCharges(outbound, chargeRules));
        const weightUOM = outbound?.weightUnits || outbound?.scaleWeightUnits;
        const net = calcNetWeight(outbound, setWeightError, weightUOM);
        const nextNetWeight = net != null ? net : null;
        if (outbound?.netWeight !== nextNetWeight) {
          form.change("netWeight", nextNetWeight);
        }
        if (weightUOM && outbound?.weightUnits !== weightUOM) {
          form.change("weightUnits", weightUOM);
        }
      },
      { values: true },
    );

    return () => unsubscribe();
  }, [chargeRules, form]);

  useEffect(() => {
    handlePickListWeight(form, setWeightError);
  }, [shipmentLineItems?.items]);

  const defaultSort = { field: "sortKey", order: "ASC" };
  const accountFields =
    account?.inventoryCustomFields?.length > 0
      ? account.inventoryCustomFields
      : [];
  const customGridFields = accountFields
    ? accountFields.map((field, index) => {
        return (
          <CustomField
            source={`inventory.customFields[${index}]`}
            field={field}
            label={field.name}
            sortable={true}
          />
        );
      })
    : [];

  const updateShipmentLineItems = (shipmentItems) => {
    let defaultUOM = null;
    // let billingUnits = null; removed after 1.5.03
    debugger;

    if (shipmentItems.length > 0) {
      form.change("areaId", shipmentItems[0].inventory.areaId);
      form.change("zoneId", shipmentItems[0].inventory.zoneId);

      shipmentItems.forEach((item) => {
        if (!defaultUOM && item.inventory.inventoryUOM)
          defaultUOM = item.inventory.inventoryUOM;
        else if (!defaultUOM)
          defaultUOM =
            item.inventory.inboundShipment.totalUOM ||
            item.inventory.inventoryUOM;
        if (defaultUOM) form.change("totalUOM", defaultUOM);
      });
    }

    setShipmentLineItems({ items: shipmentItems });
    form.change("shipmentLineItems.items", shipmentItems);
  };

  // Subscribe to field state updates for 3rd party inputs
  form.registerField(
    "shipmentLineItems",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "shipmentLineItems.items",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "areaId",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "zoneId",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );

  form.registerField(
    "totalUOM",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );

  const listContext = useList({
    ...props,
    data: shipmentLineItems.items,
    ids: shipmentLineItems.items.map(({ id }) => id),
    loaded: true,
    sort: defaultSort,
  });

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <ListContextProvider value={listContext}>
              <CustomizableDatagrid
                label="PICK LIST:"
                hasBulkActions={false}
                rowClick="expand"
                expand={
                  <InventoryItemsArrayInput
                    inventories={shipmentLineItems}
                    setInventories={updateShipmentLineItems}
                  />
                }
                storageProp={`OutboundShipmentLineItems_${account?.id}_large`}
                defaultColumns={[
                  "inventory.productName",
                  "lotNumber",
                  // "inventory.quantityOnHand",
                  // "inventory.quantityCommitted",
                  "inventory.quantityAvaiable",
                  "totalQuantityToPick",
                  "inventory.inventoryUOM",
                ]}
              >
                {[
                  <FunctionField
                    source="inventory.productName"
                    label="Product Name"
                    sortable={true}
                    render={(record) =>
                      record && (
                        <>
                          {record.inventory.productName}{" "}
                          {getInfoBubble(formData, record)}{" "}
                        </>
                      )
                    }
                  />,
                  <FunctionField
                    source="pcs"
                    label="Pieces"
                    render={piecesRenderer}
                  />,
                  <TextField source="lotNumber" label="Lot Number" />,
                  <TextField source="inventory.poNumber" label="PO Number" />,
                  <NumberField
                    source="inventory.quantityOnHand"
                    label="Qty. On Hand"
                  />,
                  <NumberField
                    source="inventory.quantityCommitted"
                    label="Qty. Committed"
                  />,
                  <FunctionField
                    source="inventory.quantityAvaiable"
                    label="Qty. Available"
                    sortable={false}
                    render={(record) =>
                      record &&
                      `${
                        record.inventory.quantityOnHand -
                        record.inventory.quantityCommitted
                      }`
                    }
                  />,
                  <NumberField
                    source="totalQuantityToPick"
                    label="Qty. Outbound"
                  />,
                  <TextField source="inventory.inventoryUOM" label="UOM" />,
                  ...customGridFields,
                  <ShipmentItemCreateActionButtons
                    inventories={shipmentLineItems}
                    setInventories={updateShipmentLineItems}
                  />,
                ]}
              </CustomizableDatagrid>
            </ListContextProvider>
          </Grid>
          <Grid item xs={12}>
            <Button
              label="Add"
              color="default"
              disabled={!account}
              onClick={() => setIsOpen(true)}
            >
              <AddIcon />
            </Button>
          </Grid>
          <InventorySearchDialog
            {...props}
            isContainerPickUp={isContainerPickUp}
            title="Inventory Search"
            form={form}
            account={account}
            allInventories={allInventories}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            isLoaded={isLoaded}
            updateShipment={updateShipmentLineItems}
          />
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Total Load
            </Typography>
            <Grid container direction="row" spacing={1}>
              <Grid item xs={6} md={3}>
                <MuiTextField
                  label="Total Quantity"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled
                  value={calcTotalQuantity(formData) ?? ""}
                  InputProps={{ endAdornment: formData.totalUOM }}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <NumberInput
                  source="netWeight"
                  label="Est. Net Weight"
                  variant="outlined"
                  fullWidth
                  disabled
                  helperText={weightError ? weightError : false}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment:
                      formData?.scaleWeightUnits || formData?.weightUnits || "",
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          {!formData?.skipInvoice && (
            <fieldset style={{ width: "100%" }}>
              <legend>
                <Typography variant="overline" color="textSecondary">
                  Billing <NewBadge />
                </Typography>
              </legend>

              <Grid container spacing={8}>
                <Grid item xs={12} md={6}>
                  <Typography variant="overline" color="textSecondary">
                    Auto Charges
                  </Typography>
                  <ArrayField
                    record={autoCharges}
                    source="items"
                    label={false}
                    fullWidth
                  >
                    <Datagrid>
                      <FunctionField
                        label="Service"
                        render={(record) => {
                          // Extract service name from serviceNote
                          const parts = record?.serviceNote?.split(" - ") || [];
                          return parts[0] || "";
                        }}
                      />
                      <FunctionField
                        label="Quantity"
                        render={(record) => {
                          const qty = Number(record?.quantity || 0);
                          const units = record?.units || "";
                          return qty ? `${qty} ${getUnitName(units)}` : "";
                        }}
                      />
                      <FunctionField
                        label="Est. Charge"
                        render={(record) => {
                          const amount = Number(record?.amount || 0);
                          return amount ? `$${amount.toFixed(2)}` : "";
                        }}
                      />
                    </Datagrid>
                  </ArrayField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="overline" color="textSecondary">
                    Manual Charges
                  </Typography>
                  <SmartTipIcon
                    label="manual-charges"
                    alignRight={false}
                    mt={20}
                  />
                  <ArrayInput
                    source="manualCharges.items"
                    label={false}
                    fullWidth
                    disabled={!chargeRules?.length}
                  >
                    <SimpleFormIterator disableReordering={true}>
                      <FormDataConsumer>
                        {({ getSource, scopedFormData }) => {
                          const applicableRules = filterApplicableManualRules(
                            formData,
                            chargeRules,
                            ChargeEvent.OUTBOUND,
                          );
                          const selectedRule = applicableRules.find(
                            (rule) => rule.id === scopedFormData?.chargeRuleId,
                          );
                          const billingUOM = getUnitName(
                            selectedRule?.billingUOM,
                          );

                          return (
                            <Grid container direction="row" spacing={1}>
                              <Grid item xs={7}>
                                <SelectInput
                                  source={getSource("chargeRuleId")}
                                  label="Service"
                                  variant="outlined"
                                  fullWidth
                                  helperText={false}
                                  choices={getManualRuleChoices(
                                    applicableRules,
                                    scopedFormData,
                                  )}
                                  onChange={(value) =>
                                    applyManualRuleDefaultQuantity({
                                      value,
                                      applicableRules,
                                      formData,
                                      scopedFormData,
                                      form,
                                      getSource,
                                    })
                                  }
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <NumberInput
                                  source={getSource("quantity")}
                                  label="Quantity"
                                  variant="outlined"
                                  fullWidth
                                  min="0"
                                  validate={[required(), number(), minValue(0)]}
                                  helperText={getManualChargeAmount(
                                    selectedRule,
                                    scopedFormData,
                                  )}
                                  InputProps={{
                                    endAdornment: billingUOM,
                                  }}
                                />
                              </Grid>
                            </Grid>
                          );
                        }}
                      </FormDataConsumer>
                    </SimpleFormIterator>
                  </ArrayInput>
                </Grid>
              </Grid>
            </fieldset>
          )}
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const DispatchTab = ({
  account,
  selectedTimeslot,
  setSelectedTimeslot,
  ...props
}) => {
  const form = useForm();
  const notify = useNotify();
  const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
  const [eventType, setEventType] = useState(null);

  form.registerField(
    "scheduledDateTime",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "arrivalDateTime",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );

  const handleTimeslot = (timeslot) => {
    if (timeslot) {
      const scheduledDate = resolveScheduledDateTime(timeslot, {
        notify,
        scope: "outboundShipments:OutboundCreate:DispatchTab:handleTimeslot",
      });
      if (!scheduledDate) return;
      form.change("scheduledDateTime", scheduledDate);
      setSelectedTimeslot(timeslot);
      if (timeslot.eventType) setEventType(timeslot.eventType);
    } else {
      form.change("scheduledDateTime", null);
      setSelectedTimeslot(null);
    }
  };

  // A picked (unsaved) appointment carries the pick-time account's auth
  // groups; saving it under a different account would leave the Timeslot
  // row authorized to the old account's customers. Reset it like the other
  // account-linked fields.
  useEffect(() => {
    if (
      selectedTimeslot &&
      account?.id &&
      selectedTimeslot.accountId &&
      selectedTimeslot.accountId !== account.id
    ) {
      handleTimeslot(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account?.id, selectedTimeslot]);

  const handleSchedulerOpen = (event, formData) => {
    event.preventDefault();
    event.stopPropagation();
    if (isInternalTransfer(formData)) return;
    if (account) setIsSchedulerOpen(true);
  };

  const getSchedulerHelperText = (formData) => {
    const events = window.appUser.reloadYard.eventTypes?.items?.length;
    if (!events) return `Setup Schedule and Event Type to enable.`;
    if (!account) return "Choose an account before scheduling.";
    if (isInternalTransfer(formData))
      return "Internal transfers do not need appointments.";
    return false;
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <FormDataConsumer>
        {({ formData }) => (
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={3}>
              <DateTimePicker
                label="Time Scheduled"
                margin="dense"
                inputVariant="outlined"
                variant="dialog"
                fullWidth
                disabled={!account || isInternalTransfer(formData)}
                onClickCapture={(event) => handleSchedulerOpen(event, formData)}
                value={
                  !formData.scheduledDateTime
                    ? null
                    : getDateTimeFromUtc(formData.scheduledDateTime)
                }
                format="MM/dd/yyyy hh:mm a"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CreatedAtIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={() => {}}
                helperText={getSchedulerHelperText(formData)}
              />
              {account && (
                <Scheduler
                  account={account}
                  eventType={eventType}
                  setEventType={setEventType}
                  selectedTimeslot={selectedTimeslot}
                  setSelectedTimeslot={handleTimeslot}
                  open={isSchedulerOpen}
                  setIsOpen={setIsSchedulerOpen}
                  resettable={true}
                  workflow={Workflow.OUTBOUND}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={3}>
                  <DateTimePicker
                    label="Time Arrived"
                    fullWidth
                    disableFuture
                    showTodayButton
                    clearable
                    margin="dense"
                    inputVariant="outlined"
                    variant="dialog"
                    value={
                      !formData.arrivalDateTime
                        ? null
                        : formData.arrivalDateTime
                    }
                    onChange={(value) => form.change("arrivalDateTime", value)}
                    format="MM/dd/yyyy hh:mm a"
                    helperText="Stamped by driver gate check-in, or set manually."
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <ArrivedAtIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                {formData.carrierType === CarrierType.TRUCK &&
                  isEmpty(formData.transfer) && (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <CarrierNameInput
                          source="carrierName"
                          label="Carrier Name"
                          validate={validateCarrierName}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <TextInput
                          source="railCarNumber"
                          label="Trailer Number"
                          variant="outlined"
                          fullWidth
                          parse={(v) => v.toUpperCase()}
                          inputProps={{
                            style: { textTransform: "uppercase" },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <CopyToClipboardButton
                                  text={formData.railCarNumber || ""}
                                  edge="end"
                                  fontSize="small"
                                  mb={0}
                                />
                              </InputAdornment>
                            ),
                          }}
                          helperText={false}
                        />
                      </Grid>
                    </>
                  )}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <EventsCalendar
                eventType={eventType}
                selectedTimeslot={selectedTimeslot}
                account={account}
                onTimeslotPick={account ? handleTimeslot : undefined}
                disableClick
              />
            </Grid>
          </Grid>
        )}
      </FormDataConsumer>
    </MuiPickersUtilsProvider>
  );
};

const OutboundCreateActions = ({ basePath, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <OutboundCreateHelp {...props} />
    </HelpButton>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

const validateCreate = (allValues) => {
  const errors = {};

  if (
    !isEmpty(allValues.transfer) &&
    isInternalTransfer(allValues) &&
    allValues.shipmentLineItems?.items?.length === 0
  ) {
    errors.shipmentLineItems = {
      items: {
        message: "A Transfer requires at least one valid Pick List line item.",
      },
    };
  }
  return errors;
};

export const OutboundCreate = (props) => {
  const [account, setAccount] = useState();
  const [toAccount, setToAccount] = useState();
  const [operatingAccount, setOperatingAccount] = useState();
  const [selectedTimeslot, setSelectedTimeslot] = useState();
  const [isContainerPickUp, setIsContainerPickUp] = useState(false);
  const [shipmentLineItems, setShipmentLineItems] = useState({ items: [] });
  const [allInventories, setAllInventories] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Outbound" />}
      actions={<OutboundCreateActions {...props} />}
    >
      <TabbedForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={
          <OutboundCreateToolbar
            fromAccount={account}
            toAccount={toAccount}
            operatingAccount={operatingAccount}
            selectedTimeslot={selectedTimeslot}
            photos={photos}
            setAllInventories={setAllInventories}
            setIsLoaded={setIsLoaded}
          />
        }
        validate={validateCreate}
      >
        <FormTab path="" label="Outbound Setup">
          <ShipmentSetupTab
            {...props}
            account={account}
            setAccount={setAccount}
            toAccount={toAccount}
            setToAccount={setToAccount}
            operatingAccount={operatingAccount}
            setIsContainerPickUp={setIsContainerPickUp}
            setOperatingAccount={setOperatingAccount}
            setShipmentLineItems={setShipmentLineItems}
            photos={photos}
            setPhotos={setPhotos}
          />
        </FormTab>
        <FormTab path="pickList" label="Tally Sheet">
          <PickListTab
            {...props}
            isContainerPickUp={isContainerPickUp}
            account={account}
            operatingAccount={operatingAccount}
            shipmentLineItems={shipmentLineItems}
            setShipmentLineItems={setShipmentLineItems}
            allInventories={allInventories}
            setAllInventories={setAllInventories}
            isLoaded={isLoaded}
            setIsLoaded={setIsLoaded}
          />
        </FormTab>
        <FormTab path="dispatch" label="Dispatch">
          <DispatchTab
            {...props}
            account={account}
            selectedTimeslot={selectedTimeslot}
            setSelectedTimeslot={setSelectedTimeslot}
          />
        </FormTab>
        <FormTab path="notes" label="Notes">
          <NotesTab />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

const OutboundCreateToolbar = ({
  fromAccount,
  toAccount,
  operatingAccount,
  selectedTimeslot,
  photos,
  setAllInventories,
  setIsLoaded,
  ...props
}) => {
  return (
    <Toolbar {...props}>
      <ValidateCreateButton
        label="Save"
        fromAccount={fromAccount}
        toAccount={toAccount}
        operatingAccount={operatingAccount}
        selectedTimeslot={selectedTimeslot}
        photos={photos}
        setAllInventories={setAllInventories}
        setIsLoaded={setIsLoaded}
      />
    </Toolbar>
  );
};
